var React = require('react');

function ArrowL (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.97026 15.8774L3.18552 9.30189L24 9.30189L24 7.69811L3.18552 7.69811L9.97026 1.12264L8.77052 -6.65702e-07L1.15837 7.37736L-3.71547e-07 8.5L1.15837 9.62264L8.77052 17L9.97026 15.8774Z","fill":"#020430"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"17","height":"24","fill":"white","transform":"translate(24) rotate(90)"})))]);
}

ArrowL.defaultProps = {"width":"24","height":"17","viewBox":"0 0 24 17","fill":"none"};

module.exports = ArrowL;

ArrowL.default = ArrowL;
